import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import React, { FunctionComponent } from "react";

interface Props {
  text: string;
  onEdit?: () => void;
}

export const EditableTextRow: FunctionComponent<Props> = ({ text, onEdit }) => (
  <div className="flex items-center justify-between gap-1">
    <span className="min-w-0 truncate" title={text}>
      {text}
    </span>
    {onEdit && (
      <IconButton
        size="small"
        color="inherit"
        className="p-0 flex-shrink-0"
        onClick={onEdit}
      >
        <EditIcon />
      </IconButton>
    )}
  </div>
);
